export const curriculumInitialState = [
  {
    id: "",
    name: "",
    program_type: "",
    admission_type: "",
    stream: "",
    owner: "",
    payment_rate: "",
    starting_date: "",
    programDuration: "",
    active: "",
  },
];
